export interface CountryData {
  code: string;
  name: string;
  currency: string;
  currencySymbol: string;
  phoneCode: string;
  flag: string;
}

export const COUNTRIES: CountryData[] = [
  {
    code: 'IN',
    name: 'India',
    currency: 'INR',
    currencySymbol: '₹',
    phoneCode: '+91',
    flag: '🇮🇳',
  },
  {
    code: 'US',
    name: 'United States',
    currency: 'USD',
    currencySymbol: '$',
    phoneCode: '+1',
    flag: '🇺🇸',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    currency: 'GBP',
    currencySymbol: '£',
    phoneCode: '+44',
    flag: '🇬🇧',
  },
  {
    code: 'CA',
    name: 'Canada',
    currency: 'CAD',
    currencySymbol: 'C$',
    phoneCode: '+1',
    flag: '🇨🇦',
  },
  {
    code: 'AU',
    name: 'Australia',
    currency: 'AUD',
    currencySymbol: 'A$',
    phoneCode: '+61',
    flag: '🇦🇺',
  },
  {
    code: 'DE',
    name: 'Germany',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+49',
    flag: '🇩🇪',
  },
  {
    code: 'FR',
    name: 'France',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+33',
    flag: '🇫🇷',
  },
  {
    code: 'IT',
    name: 'Italy',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+39',
    flag: '🇮🇹',
  },
  {
    code: 'ES',
    name: 'Spain',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+34',
    flag: '🇪🇸',
  },
  {
    code: 'NL',
    name: 'Netherlands',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+31',
    flag: '🇳🇱',
  },
  {
    code: 'BE',
    name: 'Belgium',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+32',
    flag: '🇧🇪',
  },
  {
    code: 'CH',
    name: 'Switzerland',
    currency: 'CHF',
    currencySymbol: 'CHF',
    phoneCode: '+41',
    flag: '🇨🇭',
  },
  {
    code: 'AT',
    name: 'Austria',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+43',
    flag: '🇦🇹',
  },
  {
    code: 'SE',
    name: 'Sweden',
    currency: 'SEK',
    currencySymbol: 'kr',
    phoneCode: '+46',
    flag: '🇸🇪',
  },
  {
    code: 'NO',
    name: 'Norway',
    currency: 'NOK',
    currencySymbol: 'kr',
    phoneCode: '+47',
    flag: '🇳🇴',
  },
  {
    code: 'DK',
    name: 'Denmark',
    currency: 'DKK',
    currencySymbol: 'kr',
    phoneCode: '+45',
    flag: '🇩🇰',
  },
  {
    code: 'FI',
    name: 'Finland',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+358',
    flag: '🇫🇮',
  },
  {
    code: 'PL',
    name: 'Poland',
    currency: 'PLN',
    currencySymbol: 'zł',
    phoneCode: '+48',
    flag: '🇵🇱',
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
    currency: 'CZK',
    currencySymbol: 'Kč',
    phoneCode: '+420',
    flag: '🇨🇿',
  },
  {
    code: 'HU',
    name: 'Hungary',
    currency: 'HUF',
    currencySymbol: 'Ft',
    phoneCode: '+36',
    flag: '🇭🇺',
  },
  {
    code: 'RO',
    name: 'Romania',
    currency: 'RON',
    currencySymbol: 'lei',
    phoneCode: '+40',
    flag: '🇷🇴',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    currency: 'BGN',
    currencySymbol: 'лв',
    phoneCode: '+359',
    flag: '🇧🇬',
  },
  {
    code: 'HR',
    name: 'Croatia',
    currency: 'HRK',
    currencySymbol: 'kn',
    phoneCode: '+385',
    flag: '🇭🇷',
  },
  {
    code: 'SI',
    name: 'Slovenia',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+386',
    flag: '🇸🇮',
  },
  {
    code: 'SK',
    name: 'Slovakia',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+421',
    flag: '🇸🇰',
  },
  {
    code: 'LT',
    name: 'Lithuania',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+370',
    flag: '🇱🇹',
  },
  {
    code: 'LV',
    name: 'Latvia',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+371',
    flag: '🇱🇻',
  },
  {
    code: 'EE',
    name: 'Estonia',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+372',
    flag: '🇪🇪',
  },
  {
    code: 'IE',
    name: 'Ireland',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+353',
    flag: '🇮🇪',
  },
  {
    code: 'PT',
    name: 'Portugal',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+351',
    flag: '🇵🇹',
  },
  {
    code: 'GR',
    name: 'Greece',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+30',
    flag: '🇬🇷',
  },
  {
    code: 'CY',
    name: 'Cyprus',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+357',
    flag: '🇨🇾',
  },
  {
    code: 'MT',
    name: 'Malta',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+356',
    flag: '🇲🇹',
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+352',
    flag: '🇱🇺',
  },
  {
    code: 'JP',
    name: 'Japan',
    currency: 'JPY',
    currencySymbol: '¥',
    phoneCode: '+81',
    flag: '🇯🇵',
  },
  {
    code: 'KR',
    name: 'South Korea',
    currency: 'KRW',
    currencySymbol: '₩',
    phoneCode: '+82',
    flag: '🇰🇷',
  },
  {
    code: 'CN',
    name: 'China',
    currency: 'CNY',
    currencySymbol: '¥',
    phoneCode: '+86',
    flag: '🇨🇳',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    currency: 'HKD',
    currencySymbol: 'HK$',
    phoneCode: '+852',
    flag: '🇭🇰',
  },
  {
    code: 'SG',
    name: 'Singapore',
    currency: 'SGD',
    currencySymbol: 'S$',
    phoneCode: '+65',
    flag: '🇸🇬',
  },
  {
    code: 'MY',
    name: 'Malaysia',
    currency: 'MYR',
    currencySymbol: 'RM',
    phoneCode: '+60',
    flag: '🇲🇾',
  },
  {
    code: 'TH',
    name: 'Thailand',
    currency: 'THB',
    currencySymbol: '฿',
    phoneCode: '+66',
    flag: '🇹🇭',
  },
  {
    code: 'ID',
    name: 'Indonesia',
    currency: 'IDR',
    currencySymbol: 'Rp',
    phoneCode: '+62',
    flag: '🇮🇩',
  },
  {
    code: 'PH',
    name: 'Philippines',
    currency: 'PHP',
    currencySymbol: '₱',
    phoneCode: '+63',
    flag: '🇵🇭',
  },
  {
    code: 'VN',
    name: 'Vietnam',
    currency: 'VND',
    currencySymbol: '₫',
    phoneCode: '+84',
    flag: '🇻🇳',
  },
  {
    code: 'TW',
    name: 'Taiwan',
    currency: 'TWD',
    currencySymbol: 'NT$',
    phoneCode: '+886',
    flag: '🇹🇼',
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    currency: 'NZD',
    currencySymbol: 'NZ$',
    phoneCode: '+64',
    flag: '🇳🇿',
  },
  {
    code: 'ZA',
    name: 'South Africa',
    currency: 'ZAR',
    currencySymbol: 'R',
    phoneCode: '+27',
    flag: '🇿🇦',
  },
  {
    code: 'EG',
    name: 'Egypt',
    currency: 'EGP',
    currencySymbol: 'E£',
    phoneCode: '+20',
    flag: '🇪🇬',
  },
  {
    code: 'NG',
    name: 'Nigeria',
    currency: 'NGN',
    currencySymbol: '₦',
    phoneCode: '+234',
    flag: '🇳🇬',
  },
  {
    code: 'KE',
    name: 'Kenya',
    currency: 'KES',
    currencySymbol: 'KSh',
    phoneCode: '+254',
    flag: '🇰🇪',
  },
  {
    code: 'GH',
    name: 'Ghana',
    currency: 'GHS',
    currencySymbol: '₵',
    phoneCode: '+233',
    flag: '🇬🇭',
  },
  {
    code: 'MA',
    name: 'Morocco',
    currency: 'MAD',
    currencySymbol: 'MAD',
    phoneCode: '+212',
    flag: '🇲🇦',
  },
  {
    code: 'TN',
    name: 'Tunisia',
    currency: 'TND',
    currencySymbol: 'د.ت',
    phoneCode: '+216',
    flag: '🇹🇳',
  },
  {
    code: 'DZ',
    name: 'Algeria',
    currency: 'DZD',
    currencySymbol: 'د.ج',
    phoneCode: '+213',
    flag: '🇩🇿',
  },
  {
    code: 'BR',
    name: 'Brazil',
    currency: 'BRL',
    currencySymbol: 'R$',
    phoneCode: '+55',
    flag: '🇧🇷',
  },
  {
    code: 'AR',
    name: 'Argentina',
    currency: 'ARS',
    currencySymbol: '$',
    phoneCode: '+54',
    flag: '🇦🇷',
  },
  {
    code: 'CL',
    name: 'Chile',
    currency: 'CLP',
    currencySymbol: '$',
    phoneCode: '+56',
    flag: '🇨🇱',
  },
  {
    code: 'CO',
    name: 'Colombia',
    currency: 'COP',
    currencySymbol: '$',
    phoneCode: '+57',
    flag: '🇨🇴',
  },
  {
    code: 'PE',
    name: 'Peru',
    currency: 'PEN',
    currencySymbol: 'S/',
    phoneCode: '+51',
    flag: '🇵🇪',
  },
  {
    code: 'MX',
    name: 'Mexico',
    currency: 'MXN',
    currencySymbol: '$',
    phoneCode: '+52',
    flag: '🇲🇽',
  },
  {
    code: 'RU',
    name: 'Russia',
    currency: 'RUB',
    currencySymbol: '₽',
    phoneCode: '+7',
    flag: '🇷🇺',
  },
  {
    code: 'TR',
    name: 'Turkey',
    currency: 'TRY',
    currencySymbol: '₺',
    phoneCode: '+90',
    flag: '🇹🇷',
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    currency: 'SAR',
    currencySymbol: '﷼',
    phoneCode: '+966',
    flag: '🇸🇦',
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    currency: 'AED',
    currencySymbol: 'د.إ',
    phoneCode: '+971',
    flag: '🇦🇪',
  },
  {
    code: 'IL',
    name: 'Israel',
    currency: 'ILS',
    currencySymbol: '₪',
    phoneCode: '+972',
    flag: '🇮🇱',
  },
  {
    code: 'JO',
    name: 'Jordan',
    currency: 'JOD',
    currencySymbol: 'د.ا',
    phoneCode: '+962',
    flag: '🇯🇴',
  },
  {
    code: 'LB',
    name: 'Lebanon',
    currency: 'LBP',
    currencySymbol: 'ل.ل',
    phoneCode: '+961',
    flag: '🇱🇧',
  },
  {
    code: 'KW',
    name: 'Kuwait',
    currency: 'KWD',
    currencySymbol: 'د.ك',
    phoneCode: '+965',
    flag: '🇰🇼',
  },
  {
    code: 'QA',
    name: 'Qatar',
    currency: 'QAR',
    currencySymbol: 'ر.ق',
    phoneCode: '+974',
    flag: '🇶🇦',
  },
  {
    code: 'BH',
    name: 'Bahrain',
    currency: 'BHD',
    currencySymbol: 'د.ب',
    phoneCode: '+973',
    flag: '🇧🇭',
  },
  {
    code: 'OM',
    name: 'Oman',
    currency: 'OMR',
    currencySymbol: 'ر.ع.',
    phoneCode: '+968',
    flag: '🇴🇲',
  },
  {
    code: 'PK',
    name: 'Pakistan',
    currency: 'PKR',
    currencySymbol: '₨',
    phoneCode: '+92',
    flag: '🇵🇰',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    currency: 'BDT',
    currencySymbol: '৳',
    phoneCode: '+880',
    flag: '🇧🇩',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    currency: 'LKR',
    currencySymbol: '₨',
    phoneCode: '+94',
    flag: '🇱🇰',
  },
  {
    code: 'NP',
    name: 'Nepal',
    currency: 'NPR',
    currencySymbol: '₨',
    phoneCode: '+977',
    flag: '🇳🇵',
  },
  {
    code: 'BT',
    name: 'Bhutan',
    currency: 'BTN',
    currencySymbol: 'Nu.',
    phoneCode: '+975',
    flag: '🇧🇹',
  },
  {
    code: 'MV',
    name: 'Maldives',
    currency: 'MVR',
    currencySymbol: 'ރ.',
    phoneCode: '+960',
    flag: '🇲🇻',
  },
  {
    code: 'AF',
    name: 'Afghanistan',
    currency: 'AFN',
    currencySymbol: '؋',
    phoneCode: '+93',
    flag: '🇦🇫',
  },
  {
    code: 'IR',
    name: 'Iran',
    currency: 'IRR',
    currencySymbol: '﷼',
    phoneCode: '+98',
    flag: '🇮🇷',
  },
  {
    code: 'IQ',
    name: 'Iraq',
    currency: 'IQD',
    currencySymbol: 'د.ع',
    phoneCode: '+964',
    flag: '🇮🇶',
  },
  {
    code: 'SY',
    name: 'Syria',
    currency: 'SYP',
    currencySymbol: '£',
    phoneCode: '+963',
    flag: '🇸🇾',
  },
  {
    code: 'YE',
    name: 'Yemen',
    currency: 'YER',
    currencySymbol: '﷼',
    phoneCode: '+967',
    flag: '🇾🇪',
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    currency: 'UZS',
    currencySymbol: 'лв',
    phoneCode: '+998',
    flag: '🇺🇿',
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    currency: 'KZT',
    currencySymbol: '₸',
    phoneCode: '+7',
    flag: '🇰🇿',
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    currency: 'KGS',
    currencySymbol: 'лв',
    phoneCode: '+996',
    flag: '🇰🇬',
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    currency: 'TJS',
    currencySymbol: 'SM',
    phoneCode: '+992',
    flag: '🇹🇯',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    currency: 'TMT',
    currencySymbol: 'T',
    phoneCode: '+993',
    flag: '🇹🇲',
  },
  {
    code: 'MN',
    name: 'Mongolia',
    currency: 'MNT',
    currencySymbol: '₮',
    phoneCode: '+976',
    flag: '🇲🇳',
  },
  {
    code: 'GE',
    name: 'Georgia',
    currency: 'GEL',
    currencySymbol: '₾',
    phoneCode: '+995',
    flag: '🇬🇪',
  },
  {
    code: 'AM',
    name: 'Armenia',
    currency: 'AMD',
    currencySymbol: '֏',
    phoneCode: '+374',
    flag: '🇦🇲',
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    currency: 'AZN',
    currencySymbol: '₼',
    phoneCode: '+994',
    flag: '🇦🇿',
  },
  {
    code: 'BY',
    name: 'Belarus',
    currency: 'BYN',
    currencySymbol: 'Br',
    phoneCode: '+375',
    flag: '🇧🇾',
  },
  {
    code: 'MD',
    name: 'Moldova',
    currency: 'MDL',
    currencySymbol: 'L',
    phoneCode: '+373',
    flag: '🇲🇩',
  },
  {
    code: 'UA',
    name: 'Ukraine',
    currency: 'UAH',
    currencySymbol: '₴',
    phoneCode: '+380',
    flag: '🇺🇦',
  },
  {
    code: 'RS',
    name: 'Serbia',
    currency: 'RSD',
    currencySymbol: 'дин.',
    phoneCode: '+381',
    flag: '🇷🇸',
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    currency: 'BAM',
    currencySymbol: 'КМ',
    phoneCode: '+387',
    flag: '🇧🇦',
  },
  {
    code: 'ME',
    name: 'Montenegro',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+382',
    flag: '🇲🇪',
  },
  {
    code: 'MK',
    name: 'North Macedonia',
    currency: 'MKD',
    currencySymbol: 'ден',
    phoneCode: '+389',
    flag: '🇲🇰',
  },
  {
    code: 'AL',
    name: 'Albania',
    currency: 'ALL',
    currencySymbol: 'L',
    phoneCode: '+355',
    flag: '🇦🇱',
  },
  {
    code: 'XK',
    name: 'Kosovo',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+383',
    flag: '🇽🇰',
  },
  {
    code: 'IS',
    name: 'Iceland',
    currency: 'ISK',
    currencySymbol: 'kr',
    phoneCode: '+354',
    flag: '🇮🇸',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    currency: 'CHF',
    currencySymbol: 'CHF',
    phoneCode: '+423',
    flag: '🇱🇮',
  },
  {
    code: 'MC',
    name: 'Monaco',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+377',
    flag: '🇲🇨',
  },
  {
    code: 'SM',
    name: 'San Marino',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+378',
    flag: '🇸🇲',
  },
  {
    code: 'VA',
    name: 'Vatican City',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+379',
    flag: '🇻🇦',
  },
  {
    code: 'AD',
    name: 'Andorra',
    currency: 'EUR',
    currencySymbol: '€',
    phoneCode: '+376',
    flag: '🇦🇩',
  },
];
